<template>
  <!-- 箱子入库资料 현황(2026-10-16 杨英文 #56) — 박스별 입고자료 사진 업로드 상태. 누락(사진 0장·완료 미표시)만 모아 볼 수 있다. 중국어(한국어 병기) -->
  <div class="container-fluid bps">
    <b-card no-body class="mb-3">
      <b-card-body>
        <h5 class="mb-3">箱子入库资料<small class="text-muted ml-1">(박스 입고자료 현황)</small></h5>
        <div class="d-flex flex-wrap align-items-center" style="gap:8px">
          <b-form-input v-model="date" size="sm" style="width:130px" placeholder="日期 MMDD(날짜)" maxlength="4" @keyup.enter="load"></b-form-input>
          <b-form-input v-model="companyid" size="sm" style="width:150px" placeholder="货主(화주)" @keyup.enter="load"></b-form-input>
          <b-form-input v-model="q" size="sm" style="width:170px" placeholder="箱号(박스번호)" @keyup.enter="load"></b-form-input>
          <b-form-checkbox v-model="onlyMissing" switch @change="load">只看缺失<small>(누락만)</small></b-form-checkbox>
          <b-button size="sm" variant="primary" :disabled="loading" @click="load">搜索<small>(조회)</small></b-button>
          <span class="small text-muted ml-2">共 {{ total }}箱 · <b class="text-danger">缺失 {{ missing }}</b></span>
        </div>
        <div v-if="error" class="small text-danger mt-2">{{ error }}</div>
      </b-card-body>
    </b-card>
    <div class="table-responsive bg-white">
      <table class="table table-sm table-hover mb-0">
        <thead class="thead-light">
          <tr>
            <th>箱号<small>(박스번호)</small></th>
            <th>货主<small>(화주)</small></th>
            <th>日期<small>(날짜)</small></th>
            <th>规格<small>(규격)</small></th>
            <th class="text-center">照片<small>(사진)</small></th>
            <th>状态<small>(상태)</small></th>
            <th>最近上传<small>(최근)</small></th>
            <th>照片预览<small>(미리보기)</small></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="r in rows" :key="r.labelId" :class="{ 'table-warning': r.누락 }">
            <td class="font-weight-bold">{{ r.labelId }}</td>
            <td>{{ r.화주 }}</td>
            <td>{{ r.날짜 }}</td>
            <td>{{ r.박스크기 }}</td>
            <td class="text-center">{{ r.사진수 }}</td>
            <td>
              <b-badge v-if="r.완료" variant="success">已完成<small>(완료)</small></b-badge>
              <b-badge v-else-if="r.사진수" variant="warning">未点完成<small>(완료 미표시)</small></b-badge>
              <b-badge v-else variant="danger">未上传<small>(미업로드)</small></b-badge>
            </td>
            <td class="small">{{ timeText(r.최근) }}</td>
            <td>
              <a v-for="(u, i) in r.사진.slice(0, 4)" :key="i" :href="u" target="_blank" rel="noopener"><img :src="u" class="bps__thumb" alt=""></a>
              <small v-if="r.사진.length > 4" class="text-muted">+{{ r.사진.length - 4 }}</small>
            </td>
          </tr>
          <tr v-if="!rows.length && !loading"><td colspan="8" class="text-center text-muted py-4">暂无数据(데이터 없음)</td></tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'BoxPhotoStatus',
  data() {
    return { date: '', companyid: '', q: '', onlyMissing: false, rows: [], total: 0, missing: 0, loading: false, error: '' };
  },
  mounted() { this.load(); },
  methods: {
    timeText(v) {
      if (!v) return '-';
      const d = new Date(v);
      if (isNaN(d)) return '-';
      const p = n => String(n).padStart(2, '0');
      return `${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`;
    },
    async load() {
      this.loading = true; this.error = '';
      try {
        const { data } = await axios.post('/api/boxPhoto/status', { date: this.date.trim(), companyid: this.companyid.trim(), q: this.q.trim(), onlyMissing: this.onlyMissing });
        if (data.요청결과 !== '성공') throw new Error((data.error && data.error.errorMessage) || '查询失败');
        this.rows = data.rows; this.total = data.total; this.missing = data.누락수;
      } catch (e) {
        console.error('[boxPhotoStatus] 조회 실패:', e);
        this.error = '查询失败(조회 실패): ' + e.message;
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.bps__thumb { width: 44px; height: 44px; object-fit: cover; border-radius: 4px; margin-right: 4px; border: 1px solid #ddd; }
</style>
